import styled from "styled-components";

export const MapOuter = styled.div`
    width: 100%;
    height: ${props => (props.mode === "fixed" ? "100vh" : "100%")};
    min-height: ${props => (props.mode === "fixed" ? "auto" : "260px")};
    overflow: hidden;
    border: 1px solid #8c9a8c;
    border-radius: 10px;
    position: relative;
    display: flex;
    flex-direction: column;

    ${({mode}) =>
        mode === "fixed" &&
        `position: fixed;
        left: 0;
        top: 0;
        width: 100vw;
        height: 100vh;
        z-index: 9999;
        border: none;
        border-radius: 0;
        box-shadow: none;
        background: white;`}

    .leaflet-container {
        height: 100% !important;
        width: 100% !important;
    }
`;

export const MapDiv = styled.div`
    width: 100%;
    height: 100%;
    flex: 1;
    position: relative;
`;

export const MapLoadingOverlay = styled.div`
    position: absolute;
    inset: 0;
    z-index: 1002;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.55);
    pointer-events: none;
`;

export const ExpandButton = styled.button`
    width: 32px;
    height: 32px;
    position: absolute;
    z-index: 1001;
    background: #fff;
    right: 10px;
    top: 10px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    border-radius: 2px;
    padding: 0;
    border: 1px solid #d9d9d9;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: #f5f5f5;
        border-color: #40a9ff;
    }
`;

export const FocusBadge = styled.div`
    position: absolute;
    left: 10px;
    top: 10px;
    z-index: 1001;
    display: flex;
    align-items: center;
    gap: 8px;
    background: #fff;
    border-radius: 20px;
    padding: 4px 6px 4px 12px;
    box-shadow: rgb(0 0 0 / 30%) 0px 1px 4px -1px;
    color: #262626;
`;

export const FocusOrderNo = styled.span`
    position: relative;
    font-weight: 600;
    font-size: 13px;
    white-space: nowrap;
    cursor: pointer;
`;

export const FocusOrderNoCopyTick = styled.span`
    position: absolute;
    top: 50%;
    left: -16px;
    transform: translateY(-50%);
    display: flex;
    color: #52c41a;
    font-size: 12px;
`;

export const FocusClearButton = styled.button`
    display: flex;
    align-items: center;
    gap: 4px;
    background: none;
    border: none;
    border-left: 1px solid #e8e8e8;
    padding: 0 0 0 10px;
    margin-left: 2px;
    font-size: 13px;
    color: #595959;
    cursor: pointer;

    &:hover {
        color: #40a9ff;
    }
`;

export const ExternalPopup = styled.div`
    position: absolute;
    left: ${props => props.$left}px;
    top: ${props => props.$top}px;
    z-index: 10000;
    background-color: white;
    border-radius: 8px;
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    min-width: 280px;
    max-width: 320px;
    border: 1px solid #ddd;
`;

export const PopupContent = styled.div`
    position: relative;
    padding: 12px;
`;

export const CloseButton = styled.button`
    position: absolute;
    top: 8px;
    right: 8px;
    background: none;
    border: none;
    font-size: 18px;
    cursor: pointer;
    color: #666;

    &:hover {
        color: #000;
    }
`;
